// src/resources/sections/iamConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const IAM_CONFIG: ResourceConfig[] = [
  {
    name: "users",
    label: "Users",
    schema: "iam",
    fields: [
      { source: "email", label: "email", kind: "text", list: true, form: true },
      {
        source: "prefered_username",
        label: "prefered_username",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "id",
        label: "User ID",
        kind: "uuid",
        list: true,
        form: true,
        editDisabled: true,
      },
      {
        source: "org_id",
        label: "Org ID",
        kind: "uuid",
        list: true,
        form: true,
        editDisabled: false,
        ref: {
          resource: "orgs",
          optionText: "name",
          input: "autocomplete",
          schema: "org",
        },
      },
      {
        source: "created_at",
        label: "created_at",
        kind: "date",
        list: true,
        form: false,
      },
    ],
  },

  {
    name: "groups",
    label: "Groups",
    schema: "iam",
    fields: [
      { source: "name", label: "name", kind: "text", list: true, form: true },

      // Consolidated Member & Permission Editor
      // Uses 'group_shares' as the single source of truth
      {
        source: "shares",
        label: "Members",
        kind: "linkTable",
        list: false,
        form: true,
        linkTable: {
          label: "Members",
          junction: { resource: "group_shares", schema: "iam" },
          leftKey: "group_id",
          rightKey: "user_id",
          target: {
            resource: "users",
            schema: "iam",
            optionText: "email",
            idField: "id",
          },
          // Editable permission columns on the junction row
          extraFields: [
            {
              source: "can_create",
              kind: "boolean",
              label: "Create",
              defaultValue: true,
            },
            {
              source: "can_read",
              kind: "boolean",
              label: "Read",
              defaultValue: true,
            },
            {
              source: "can_update",
              kind: "boolean",
              label: "Update",
              defaultValue: false,
            },
            {
              source: "can_delete",
              kind: "boolean",
              label: "Delete",
              defaultValue: false,
            },
            {
              source: "can_admin",
              kind: "boolean",
              label: "Admin",
              defaultValue: true,
            },
          ],
        },
      },

      {
        source: "created_at",
        label: "created_at",
        kind: "date",
        list: true,
        form: false,
      },
    ],
    searchFields: ["name"],
  },

  // This resource is required for the API to handle the junction table requests,
  // even though we don't list it directly in the sidebar menu usually.
  {
    name: "group_shares",
    label: "Group Shares",
    schema: "iam",
    fields: [
      {
        source: "group_id",
        label: "Group",
        kind: "uuid",
        list: true,
        form: true,
        ref: {
          resource: "groups",
          optionText: "name",
          input: "autocomplete",
          schema: "iam",
        },
      },
      {
        source: "user_id",
        label: "User",
        kind: "uuid",
        list: true,
        form: true,
        ref: {
          resource: "users",
          optionText: "email",
          input: "autocomplete",
          schema: "iam",
        },
      },

      // Permissions
      {
        source: "can_create",
        label: "Create",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "can_read",
        label: "Read",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "can_update",
        label: "Update",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "can_delete",
        label: "Delete",
        kind: "boolean",
        list: true,
        form: true,
      },

      {
        source: "created_at",
        label: "Created",
        kind: "date",
        list: true,
        form: false,
      },
      {
        source: "created_by",
        label: "Created By",
        kind: "uuid",
        list: false,
        form: false,
      },
    ],
    searchFields: ["group_id", "user_id"],
  },
];
